// Generated by Avo VERSION 211.9.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
;(function () {
  if (typeof window === 'undefined') {
    return
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob()
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self,
  }

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]',
    ]

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return (
          obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
        )
      }
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift()
        return { done: value === undefined, value: value }
      },
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    ;(this as any).map = {}

    if (headers instanceof Headers) {
      ;(headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value)
        // @ts-ignore
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1])
        // @ts-ignore
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name])
        // @ts-ignore
      }, this)
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue + ', ' + value : value
  }

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function () {
    var items: any = []
    this.forEach(function (_value: any, name: any) {
      items.push(name)
    })
    return iteratorFor(items)
  }

  Headers.prototype.values = function () {
    var items: any = []
    this.forEach(function (value: any) {
      items.push(value)
    })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function () {
    var items: any = []
    this.forEach(function (value: any, name: any) {
      items.push([name, value])
    })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true
    }
    body.bodyUsed = true
    return false
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result)
      }
      reader.onerror = function () {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!)
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    ;(this as any).bodyUsed = false

    // @ts-ignore
    ;(this as any)._initBody = function (body: any) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (
        support.searchParams &&
        URLSearchParams.prototype.isPrototypeOf(body)
      ) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (
        support.arrayBuffer &&
        (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))
      ) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        this._bodyText = body = Object.prototype.toString.call(body)
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (
          support.searchParams &&
          URLSearchParams.prototype.isPrototypeOf(body)
        ) {
          this.headers.set(
            'content-type',
            'application/x-www-form-urlencoded;charset=UTF-8',
          )
        }
      }
    }

    if (support.blob) {
      // @ts-ignore
      ;(this as any).blob = function () {
        var rejected = consumed(this)
        if (rejected) {
          return Promise.reject(new TypeError('Already read'))
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      // @ts-ignore
      ;(this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'))
          } else {
            return Promise.resolve(this._bodyArrayBuffer)
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    // @ts-ignore
    ;(this as any).text = function () {
      var rejected = consumed(this)
      if (rejected) {
        return Promise.reject(new TypeError('Already read'))
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      // @ts-ignore
      ;(this as any).formData = function () {
        return this.text().then(decode)
      }
    }

    // @ts-ignore
    ;(this as any).json = function () {
      return this.text().then(JSON.parse)
    }

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase()
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      ;(this as any).url = (input as any).url
      // @ts-ignore
      this.credentials = (input as any).credentials
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers)
      }
      // @ts-ignore
      this.method = (input as any).method
      // @ts-ignore
      this.mode = (input as any).mode
      // @ts-ignore
      this.signal = (input as any).signal
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit
        ;(input as any).bodyUsed = true
      }
    } else {
      // @ts-ignore
      this.url = String(input)
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin'
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers)
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET')
    // @ts-ignore
    this.mode = options.mode || this.mode || null
    // @ts-ignore
    this.signal = options.signal || this.signal
    // @ts-ignore
    this.referrer = null

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body)
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body: any) {
    var form = new FormData()
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=')
          var name = split.shift().replace(/\+/g, ' ')
          var value = split.join('=').replace(/\+/g, ' ')
          form.append(decodeURIComponent(name), decodeURIComponent(value))
        }
      })
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {}
    }

    // @ts-ignore
    this.type = 'default'
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    // @ts-ignore
    this.headers = new Headers(options.headers)
    // @ts-ignore
    this.url = options.url || ''
    // @ts-ignore
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url,
    })
  }

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' })
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  }
  ;(self as any).DOMException = (self as any).DOMException
  try {
    new (self as any).DOMException()
  } catch (err) {
    ;(self as any).DOMException = function (message: any, name: any) {
      this.message = message
      this.name = name
      var error = Error(message)
      this.stack = error.stack
    }
    ;(self as any).DOMException.prototype = Object.create(Error.prototype)
    ;(self as any).DOMException.prototype.constructor = (
      self as any
    ).DOMException
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init)

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest()

      function abortXhr() {
        xhr.abort()
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || ''),
        }
        ;(options as any).url =
          'responseURL' in xhr
            ? xhr.responseURL
            : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText
        // @ts-ignore
        resolve(new Response(body, options))
      }

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'))
      }

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value)
      })

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr)

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr)
          }
        }
      }

      xhr.send(
        typeof request._bodyInit === 'undefined' ? null : request._bodyInit,
      )
    })
  }

  fetch.polyfill = true

  if (!self.fetch) {
    ;(self as any).fetch = fetch
    ;(self as any).Headers = Headers
    ;(self as any).Request = Request
    ;(self as any).Response = Response
  }
})()

export enum AvoEnv {
  Prod = 'prod',
  Staging = 'staging',
  Dev = 'dev',
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void
  setUserProperties?: (
    userId: string,
    userProperties: Record<string, any>,
  ) => void
  identify?: (userId: string) => void
  unidentify?: () => void
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void
  revenue?: (amount: number, eventProperties: Record<string, any>) => void
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string
  tag?: string
  propertyId?: string
  message?: string
  additionalProperties?: string[]
  shape?: any
  shapeUserProps?: any
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null
// @ts-ignore
let __AVO_NOOP__: boolean = false
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null
// @ts-ignore
let __STRICT__: boolean | null = null
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true
export const avoInspectorApiKey = 'grygBPa9PlBrQdN72eQM'
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null

// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target: any, _varArgs: any) {
      // .length of function is 2
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object')
      }

      let to = Object(target)

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index]

        if (nextSource != null) {
          // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey]
            }
          }
        }
      }
      return to
    },
    writable: true,
    configurable: true,
  })
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean
  logWarn(env: AvoEnv | null, message: string): boolean
  logError(env: AvoEnv | null, error: string): boolean
}

enum webDebuggerArea {
  BottomRight = 'BottomRight',
  BottomLeft = 'BottomLeft',
  TopRight = 'TopRight',
  TopLeft = 'TopLeft',
}

interface bottomRightParameters {
  bottom: number
  right: number
}

interface bottomLeftParameters {
  bottom: number
  left: number
}

interface topRightParameters {
  top: number
  right: number
}

interface topLeftParameters {
  top: number
  left: number
}

interface webDebuggerPosition {
  position: webDebuggerArea
  top?: number
  right?: number
  bottom?: number
  left?: number
}

interface webDebuggerOptions {
  position?: webDebuggerPosition
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition
  TopRight(p: topRightParameters): webDebuggerPosition
  TopLeft(p: topLeftParameters): webDebuggerPosition
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}

let InternalAvoLogger: any = {
  logEventSent: function logEventSent(
    eventName: string,
    eventProperties: any,
    userProperties: any,
  ) {
    const message =
      'Event Sent:' +
      eventName +
      'Event Props:' +
      JSON.stringify(eventProperties) +
      'User Props:' +
      JSON.stringify(userProperties)

    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logDebug &&
      __AVO_LOGGER__.logDebug(__AVO_ENV__, message)
    ) {
      return
    }
    typeof console !== 'undefined' &&
      console.log(
        '[avo] Event Sent:',
        eventName,
        'Event Props:',
        eventProperties,
        'User Props:',
        userProperties,
      )
  },

  log: function log(message: string) {
    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logDebug &&
      __AVO_LOGGER__.logDebug(__AVO_ENV__, message)
    ) {
      return
    }
    typeof console !== 'undefined' && console.log('[avo] ' + message)
  },

  warn: function warn(message: string) {
    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logWarn &&
      __AVO_LOGGER__.logWarn(__AVO_ENV__, message)
    ) {
      return
    }
    typeof console !== 'undefined' && console.warn('[avo] ' + message)
  },

  error: function error(message: string, error: string) {
    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logError &&
      __AVO_LOGGER__.logError(__AVO_ENV__, message + error)
    ) {
      return
    }
    typeof console !== 'undefined' && console.error('[avo] ' + message, error)
  },
}

function convertPropertiesArrayToMap(
  propertiesArray: [{ id: string; name: string; value: string }],
): { string: string | null | undefined } {
  let result: { string: string } = {}

  propertiesArray.forEach((value) => {
    result[value.name] = value.value
  })

  return result
}

// @ts-ignore
let array_difference: any
// @ts-ignore
let AvoAssert: any
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = []
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i])
    }
  }
  return result
}

AvoAssert = {
  assertObject: function assertObject(
    propertyId: string,
    propName: string,
    obj: any,
  ) {
    if (typeof obj !== 'object') {
      let message =
        propName +
        ' should be of type object but you provided type ' +
        typeof obj +
        ' with value ' +
        JSON.stringify(obj)
      return [
        {
          tag: 'expectedObjectType',
          propertyId,
          message,
          actualType: typeof obj,
        },
      ]
    } else {
      return []
    }
  },

  assertString: function assertString(
    propertyId: string,
    propName: string,
    str: string,
  ) {
    if (typeof str !== 'string') {
      let message =
        propName +
        ' should be of type string but you provided type ' +
        typeof str +
        ' with value ' +
        JSON.stringify(str)
      return [
        {
          tag: 'expectedStringType',
          propertyId,
          message,
          actualType: typeof str,
        },
      ]
    } else {
      return []
    }
  },

  assertInt: function assertInt(
    propertyId: string,
    propName: string,
    int: number,
  ) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message =
        propName +
        ' should be of type int but you provided type float with value ' +
        JSON.stringify(int)
      return [
        { tag: 'expectedIntType', propertyId, message, actualType: 'float' },
      ]
    } else if (typeof int !== 'number') {
      let message =
        propName +
        ' should be of type int but you provided type ' +
        typeof int +
        ' with value ' +
        JSON.stringify(int)
      return [
        { tag: 'expectedIntType', propertyId, message, actualType: typeof int },
      ]
    } else {
      return []
    }
  },

  assertLong: function assertLong(
    propertyId: string,
    propName: string,
    long: number,
  ) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message =
        propName +
        ' should be of type long but you provided type float with value ' +
        JSON.stringify(long)
      return [
        { tag: 'expectedLongType', propertyId, message, actualType: 'float' },
      ]
    } else if (typeof long !== 'number') {
      let message =
        propName +
        ' should be of type long but you provided type ' +
        typeof long +
        ' with value ' +
        JSON.stringify(long)
      return [
        {
          tag: 'expectedLongType',
          propertyId,
          message,
          actualType: typeof long,
        },
      ]
    } else {
      return []
    }
  },

  assertFloat: function assertFloat(
    propertyId: string,
    propName: string,
    float: number,
  ) {
    if (typeof float !== 'number') {
      let message =
        propName +
        ' should be of type float but you provided type ' +
        typeof float +
        ' with value ' +
        JSON.stringify(float)
      return [
        {
          tag: 'expectedFloatType',
          propertyId,
          message,
          actualType: typeof float,
        },
      ]
    } else {
      return []
    }
  },

  assertBool: function assertBool(
    propertyId: string,
    propName: string,
    bool: boolean,
  ) {
    if (typeof bool !== 'boolean') {
      let message =
        propName +
        ' should be of type boolean but you provided type ' +
        typeof bool +
        ' with value ' +
        JSON.stringify(bool)
      return [
        {
          tag: 'expectedBoolType',
          propertyId,
          message,
          actualType: typeof bool,
        },
      ]
    } else {
      return []
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number,
  ) {
    if (value > max) {
      let message =
        propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value)
      return [{ tag: 'expectedMax', propertyId, message }]
    } else {
      return []
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number,
  ) {
    if (value < min) {
      let message =
        propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value)
      return [{ tag: 'expectedMin', propertyId, message }]
    } else {
      return []
    }
  },

  assertList: function assertList(
    propertyId: string,
    propName: string,
    value: any,
  ) {
    if (!Array.isArray(value)) {
      let message =
        propName +
        ' should be of type list but you provided type ' +
        typeof value
      return [{ tag: 'expectedList', propertyId, message }]
    } else {
      return []
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(
    eventName: string,
    input: string[],
    spec: string[],
  ) {
    let additionalKeys = array_difference(input, spec)
    if (additionalKeys.length) {
      let message =
        'Additional properties when sending event ' +
        eventName +
        ': ' +
        JSON.stringify(additionalKeys)
      return [
        {
          tag: 'expectedNoAdditionalProperties',
          additionalProperties: additionalKeys,
          message: message,
        },
      ]
    } else {
      return []
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(
    eventName: string,
    input: string[],
    spec: string[],
  ) {
    let additionalKeys = array_difference(input, spec)
    if (additionalKeys.length) {
      let message =
        'Additional user properties when sending event ' +
        eventName +
        ': ' +
        JSON.stringify(additionalKeys)
      return [
        {
          tag: 'expectedNoAdditionalUserProperties',
          additionalProperties: additionalKeys,
          message: message,
        },
      ]
    } else {
      return []
    }
  },
}

let _avo_invoke: any
let _avo_invoke_meta: any
let _avo_sampling_rate = 1.0
_avo_invoke = function _avo_invoke(
  env: AvoEnv,
  eventId: string,
  hash: string,
  messages: { tag: string; propertyId: string }[],
  origin: string,
) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') {
    return
  }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch('https://api.avo.app/i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ac: 't5Xrk0TIB0DxoZgCBQ18',
          br: 'PsRDMgOzKdvBCPbWYW9XO',
          en: env,
          ev: eventId,
          ha: hash,
          sc: 'JmwsgKTQe50MTmUE9FVs',
          se: new Date().toISOString(),
          so: 'vZTQU-BArtQjjCvdyttoO',
          va: messages.length === 0,
          me: messages,
          or: origin,
        }),
      })
        .then(function (res: any) {
          return res.json()
        })
        .then(function (data: any) {
          _avo_sampling_rate = data.sa
        })
        .catch(function () {})
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(
  env: AvoEnv,
  type: string,
  messages: { tag: string; propertyId: string }[],
  origin: string,
) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') {
    return
  }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch('https://api.avo.app/i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ac: 't5Xrk0TIB0DxoZgCBQ18',
          br: 'PsRDMgOzKdvBCPbWYW9XO',
          en: env,
          ty: type,
          sc: 'JmwsgKTQe50MTmUE9FVs',
          se: new Date().toISOString(),
          so: 'vZTQU-BArtQjjCvdyttoO',
          va: messages.length === 0,
          me: messages,
          or: origin,
        }),
      })
        .then(function (res: any) {
          return res.json()
        })
        .then(function (data: any) {
          _avo_sampling_rate = data.sa
        })
        .catch(function () {})
    }
  }
}

let _avo_debugger_log: any
let _avo_debugger_events_during_boot: any = []
let _avo_debugger_ready = false

if (typeof (window as any) !== 'undefined') {
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://www.avo.app') {
      return
    }
    let iframe: any = document.getElementById('avo-debugger')
    if (
      iframe &&
      event &&
      event.data &&
      event.data.type_ === 'avo-debugger-update-style'
    ) {
      iframe.style = event.data.style
    } else if (
      iframe &&
      event &&
      event.data &&
      event.data.type_ === 'avo-debugger-ready'
    ) {
      let message = {
        type_: 'avo-debugger-boot-events',
        schemaId: 'JmwsgKTQe50MTmUE9FVs',
        href: window.location.href,
        events: _avo_debugger_events_during_boot,
      }
      _avo_debugger_events_during_boot = []
      _avo_debugger_ready = true
      iframe.contentWindow.postMessage(message, 'https://www.avo.app/_debugger')
    }
  })
}

_avo_debugger_log = function _avo_debugger_log(
  eventId: string,
  eventName: string,
  messages: any[],
  eventProperties: any[],
  userProperties: any[],
  groupProperties: any[],
) {
  if (typeof (window as any) === 'undefined') {
    return
  }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties,
  }

  if (_avo_debugger_ready) {
    let message = { type_: 'avo-debugger-events', events: [event] }
    ;(document.getElementById('avo-debugger') as any).contentWindow.postMessage(
      message,
      'https://www.avo.app/_debugger',
    )
  } else {
    _avo_debugger_events_during_boot.push(event)
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') {
    return
  }
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://www.avo.app') {
      return
    }
    if (event.data.type_ === 'avo-debugger-ready' && position !== null) {
      var message = { type_: 'avo-debugger-position', position: position }
      document
        .getElementById('avo-debugger')
        .contentWindow.postMessage(message, 'https://www.avo.app/_debugger')
    }
  })
}

export interface ProductsCart {
  amount: number
  variation: string
  currency: CurrencyValueType | null | undefined
  quantity: number | null | undefined
  marketingcloudpid: string
  variantId: string
  identifier: string
}

export interface CommunicationPreferences {
  communicationLanguage: string
  newsletterStatus: boolean
  curatedForYouStatus: boolean
}

export const Language = {
  EN: 'en',
  ES: 'es',
  FR: 'fr',
  DE: 'de',
  IT: 'it',
  SV: 'sv',
  PL: 'pl',
  ZH: 'zh',
  KO: 'ko',
} as const
export type LanguageType = typeof Language
export type LanguageValueType = LanguageType[keyof LanguageType]

export const LoggedIn = {
  TRUE: 'true',
  FALSE: 'false',
} as const
export type LoggedInType = typeof LoggedIn
export type LoggedInValueType = LoggedInType[keyof LoggedInType]

export const EventCategory = {
  CHECKOUT_INTERACTIONS: 'checkout_interactions',
  PLP_INTERACTIONS: 'plp_interactions',
  PDP_INTERACTIONS: 'pdp_interactions',
  GLOBAL_INTERACTIONS: 'global_interactions',
  FOOTER_INTERACTIONS: 'footer_interactions',
  JOURNAL_INTERACTIONS: 'journal_interactions',
  CM_INTERACTIONS: 'cm_interactions',
  LOOKBUILDER_INTERACTIONS: 'lookbuilder_interactions',
  INSTORE_INTERACTIONS: 'instore_interactions',
  ECOMMERCE_INTERACTIONS: 'ecommerce_interactions',
  BTC_INTERACTIONS: 'btc_interactions',
  BOOKING_INTERACTIONS: 'booking_interactions',
  LOGIN_INTERACTIONS: 'login_interactions',
  SP_INTERACTIONS: 'sp_interactions',
  CONFIGURATOR_INTERACTIONS: 'configurator_interactions',
  RETURNING_ITEM_INTERACTIONS: 'returning_item_interactions',
} as const
export type EventCategoryType = typeof EventCategory
export type EventCategoryValueType = EventCategoryType[keyof EventCategoryType]

export const Country = {
  US: 'us',
  CA: 'ca',
  NL: 'nl',
  GB: 'gb',
  DE: 'de',
  FR: 'fr',
  BE: 'be',
  IT: 'it',
  SE: 'se',
  CH: 'ch',
  PL: 'pl',
  ES: 'es',
  FI: 'fi',
  DK: 'dk',
  AT: 'at',
  NO: 'no',
  CZ: 'cz',
  HR: 'hr',
  HU: 'hu',
  EE: 'ee',
  LV: 'lv',
  LT: 'lt',
  GR: 'gr',
  IE: 'ie',
  SG: 'sg',
  IN: 'in',
  AU: 'au',
  CN: 'cn',
  BN: 'bn',
  JP: 'jp',
  HK: 'hk',
  MO: 'mo',
  MV: 'mv',
  MY: 'my',
  IR: 'ir',
  LY: 'ly',
  PT: 'pt',
  RO: 'ro',
  CY: 'cy',
  SK: 'sk',
  BG: 'bg',
  SI: 'si',
  AE: 'ae',
  GH: 'gh',
  GI: 'gi',
  GW: 'gw',
  IS: 'is',
  JE: 'je',
  LI: 'li',
  MC: 'mc',
  MT: 'mt',
  QA: 'qa',
  DO: 'do',
  GP: 'gp',
  MQ: 'mq',
  PR: 'pr',
  TT: 'tt',
  KR: 'kr',
  LU: 'lu',
} as const
export type CountryType = typeof Country
export type CountryValueType = CountryType[keyof CountryType]

export const PageType = {
  HOME: 'home',
  PRODUCT: 'product',
  CATEGORY: 'category',
  JOURNAL: 'journal',
  STORE: 'store',
  LOOKBUILDER: 'lookbuilder',
  LOGIN: 'login',
  WISHLIST: 'wishlist',
  ACCOUNT: 'account',
  CHECKOUT: 'checkout',
  CART: 'cart',
  SUPPORT: 'support',
  CUSTOMMADE: 'custommade',
  GIFTCARD: 'giftcard',
  ERROR: 'error',
  INSTORE: 'instore',
  CATEGORY_LANDING: 'category_landing',
  BLACK_TIE_CONFIGURATOR: 'black-tie-configurator',
  MINI_CART: 'mini-cart',
  BLACK_TIE_CONFIGURATOR: 'black_tie_configurator',
  PRODUCT_DETAIL_PAGE: 'product_detail_page',
  PRODUCT_LIST_PAGE: 'product_list_page',
  ORDER_CONFIRMATION: 'order_confirmation',
  BOOKING_TOOL: 'booking_tool',
  STORE_DETAILS: 'store_details',
  STORE_LOCATOR: 'store_locator',
  STORE_OVERVIEW: 'store_overview',
  RETURN: 'return',
  RETURN_CONFIRMATION: 'return_confirmation',
} as const
export type PageTypeType = typeof PageType
export type PageTypeValueType = PageTypeType[keyof PageTypeType]

export const Currency = {
  EUR: 'eur',
  USD: 'usd',
  CNY: 'cny',
  AUD: 'aud',
  BGN: 'bgn',
  CAD: 'cad',
  CZK: 'czk',
  DKK: 'dkk',
  HKD: 'hkd',
  HUF: 'huf',
  ISK: 'isk',
  INR: 'inr',
  JPY: 'jpy',
  CHF: 'chf',
  MOP: 'mop',
  MYR: 'myr',
  NOK: 'nok',
  QAR: 'qar',
  RON: 'ron',
  SGD: 'sgd',
  SEK: 'sek',
  AED: 'aed',
  GBP: 'gbp',
  PLN: 'pln',
  KRW: 'krw',
} as const
export type CurrencyType = typeof Currency
export type CurrencyValueType = CurrencyType[keyof CurrencyType]

export const ApplicationId = {
  CUSTOM_MADE: 'custom_made',
  HEADLESS: 'headless',
  LOOKBUILDER: 'lookbuilder',
  ONLINE_STORE: 'online_store',
  SIZE_PASSPORT: 'size_passport',
  BOOKING_TOOL: 'booking_tool',
  CH_RETURN_EXCHANGE: 'ch_return_exchange',
} as const
export type ApplicationIdType = typeof ApplicationId
export type ApplicationIdValueType = ApplicationIdType[keyof ApplicationIdType]

let sysApplicationId: any
let sysVersion: any
let sysClientId: any
let sysSessionId: any
let sysAffiliateMarker: any
let sysAwc: any

export function setSystemProperties(properties: {
  applicationId: ApplicationIdValueType
  version: string
  clientId: string
  sessionId: string
  affiliateMarker: string
  awc: string
}) {
  if (
    properties.applicationId !== null &&
    properties.applicationId !== undefined
  ) {
    sysApplicationId = properties.applicationId
  }
  if (properties.version !== null && properties.version !== undefined) {
    sysVersion = properties.version
  }
  if (properties.clientId !== null && properties.clientId !== undefined) {
    sysClientId = properties.clientId
  }
  if (properties.sessionId !== null && properties.sessionId !== undefined) {
    sysSessionId = properties.sessionId
  }
  if (
    properties.affiliateMarker !== null &&
    properties.affiliateMarker !== undefined
  ) {
    sysAffiliateMarker = properties.affiliateMarker
  }
  if (properties.awc !== null && properties.awc !== undefined) {
    sysAwc = properties.awc
  }
}

let Segment: any

export function initAvo(
  options: {
    env: AvoEnv
    webDebugger?: boolean
    webDebuggerOptions?: webDebuggerOptions
    strict?: boolean
    noop?: boolean
    reportFailureAs?: 'error' | 'warn' | 'log'
    inspector?: AvoInspector
    avoLogger?: AvoLogger
  },
  systemProperties: {
    applicationId: ApplicationIdValueType
    version: string
    clientId: string
    sessionId: string
    affiliateMarker: string
    awc: string
  },
  destinationOptions: any,
  SegmentDestination: CustomDestination,
) {
  if (__AVO_ENV__ !== null) {
    return
  }
  __AVO_ENV__ = options.env
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn(
      '[avo] ****************************************************',
    )
    InternalAvoLogger.warn(
      '[avo] WARNING Avo cannot be initialized in noop mode in production:',
    )
    InternalAvoLogger.warn('[avo] - Overwriting configuration with noop=false.')
    InternalAvoLogger.warn(
      '[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true',
    )
    InternalAvoLogger.warn(
      '[avo] ****************************************************',
    )
    __AVO_NOOP__ = false
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log(
      '[avo] ****************************************************',
    )
    InternalAvoLogger.log(
      '[avo] Avo is now initialized in noop mode. This means:',
    )
    InternalAvoLogger.log('[avo] - No events will be sent')
    InternalAvoLogger.log('[avo] - No network requests are made')
    InternalAvoLogger.log(
      '[avo] ****************************************************',
    )
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs
  }
  __WEB_DEBUGGER__ =
    !__AVO_NOOP__ &&
    ((typeof window !== 'undefined' &&
      (window as any).location.search.indexOf('avo_debug=1') > -1) ||
      (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod))
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn('[avo] Avo Inspector not provided in initAvo() call')
  }

  setSystemProperties(systemProperties)

  destinationOptions = destinationOptions || {}

  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

    ;(function () {
      if (typeof (window as any) === 'undefined') {
        return
      }
      let init = function () {
        let iframe: any = document.createElement('iframe')
        document.body.appendChild(iframe)
        iframe.id = 'avo-debugger'
        iframe.src = 'https://www.avo.app/_debugger'
        iframe.style = 'display: none;'
      }

      if (document.body) {
        init()
      } else {
        document.addEventListener('DOMContentLoaded', init)
      }
    })()
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    if (__AVO_ENV__ === AvoEnv.Staging) {
    }

    Segment = SegmentDestination
    if (__AVO_ENV__ === 'prod') {
      Segment &&
        Segment.make &&
        Segment.make(__AVO_ENV__, '4OhwIsrqFzQ0aeuYev8muGSWiimGtGIG')
    } else if (__AVO_ENV__ === 'dev') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null)
    } else {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null)
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init')
    }
  }
}

function assertProductsCart(productsCart: ProductsCart[], _label?: string) {
  let messages: AvoAssertMessage[] = []
  messages = messages.concat(
    AvoAssert.assertList('NbRKFviNt', 'products_cart', productsCart),
  )
  if (
    productsCart !== null &&
    productsCart !== undefined &&
    productsCart.forEach
  ) {
    productsCart.forEach(function (value, index) {
      messages = messages.concat(
        AvoAssert.assertObject(
          'NbRKFviNt',
          'item at index ' + index + ' in products_cart',
          value,
        ),
      )
      messages = messages.concat(
        assertAmount(
          value.amount,
          'item at index ' + index + ' in products_cart',
        ),
      )
      messages = messages.concat(
        assertQuantityOptional(
          value.quantity,
          'item at index ' + index + ' in products_cart',
        ),
      )
    })
  }
  return messages
}

function assertAmount(amount: number, _label?: string) {
  let messages: AvoAssertMessage[] = []
  messages = messages.concat(
    AvoAssert.assertFloat(
      'Vk6lWRKl5',
      _label ? 'amount' + ': ' + _label : 'amount',
      amount,
    ),
  )
  messages = messages.concat(
    AvoAssert.assertMin(
      'Vk6lWRKl5',
      _label ? 'amount' + ': ' + _label : 'amount',
      0.0,
      amount,
    ),
  )
  return messages
}

function assertQuantity(quantity: number, _label?: string) {
  let messages: AvoAssertMessage[] = []
  messages = messages.concat(
    AvoAssert.assertInt(
      'fg1kaNXr_',
      _label ? 'quantity' + ': ' + _label : 'quantity',
      quantity,
    ),
  )
  messages = messages.concat(
    AvoAssert.assertMin(
      'fg1kaNXr_',
      _label ? 'quantity' + ': ' + _label : 'quantity',
      1,
      quantity,
    ),
  )
  return messages
}

function assertQuantityOptional(
  quantity: number | null | undefined,
  _label?: string,
) {
  let messages: AvoAssertMessage[] = []
  if (quantity !== undefined && quantity !== null) {
    messages = messages.concat(
      AvoAssert.assertInt(
        'fg1kaNXr_',
        _label ? 'quantity' + ': ' + _label : 'quantity',
        quantity,
      ),
    )
    messages = messages.concat(
      AvoAssert.assertMin(
        'fg1kaNXr_',
        _label ? 'quantity' + ': ' + _label : 'quantity',
        1,
        quantity,
      ),
    )
  }
  return messages
}

function assertCommunicationPreferences(
  communicationPreferences: CommunicationPreferences,
  _label?: string,
) {
  let messages: AvoAssertMessage[] = []
  messages = messages.concat(
    AvoAssert.assertObject(
      'sDlh7c0yvS7a0T6AcoGcQ',
      _label
        ? 'communication_preferences' + ': ' + _label
        : 'communication_preferences',
      communicationPreferences,
    ),
  )
  if (
    communicationPreferences !== null &&
    communicationPreferences !== undefined
  ) {
  }
  return messages
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger
}

export interface PageLoadedProperties {
  customDestinationPageName_: string
  localeVisited: string
  productsCart: ProductsCart[]
  category: string
  subcategory: string
  currency: CurrencyValueType
  country: CountryValueType
  language: LanguageValueType
  locationId: string
  userId: string
  loggedIn: LoggedInValueType
  pageType: PageTypeValueType
  gaAwClid: string | null | undefined
  gaClientId: string | null | undefined
  gaSessionId: string | null | undefined
  gaSessionNumber: string | null | undefined
  fbFbp: string | null | undefined
  fbFbc: string | null | undefined
}
/**
 * Page Loaded: When a page or a virtual page is loaded
 * for custommade: products_cart and referrer not needed
 * 
 * When to trigger this event:
 * 1. Title: instore - checkin - login
url: https://suitsupply.com/en-nl//instore/checkin-login/
location_id: https://suitsupply.com/en-nl//instore/checkin-login/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/4l0ZskS226/trigger/GzKmdfzMs
 * 2. title: instore - checkin - register
location_id: https://suitsupply.com/en-nl/instore/checkin-register/
url: https://suitsupply.com/instore/checkin-register/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/4l0ZskS226/trigger/h5T0sz4zf
 * 3. title: instore - checkin - long succeeded
url: https://suitsupply.com/instore/checkin-succeeded-wait-long/
location_id: https://suitsupply.com/en-nl/instore/checkin-succeeded-wait-long/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/4l0ZskS226/trigger/WL4lVMb0g
 * 4. title: instore - checkin - short succeeded
url: https://suitsupply.com/instore/checkin-succeeded-wait-short/
location_id: https://suitsupply.com/en-nl/instore/checkin-succeeded-wait-short/
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/4l0ZskS226/trigger/Djt5Cknvx
 * 
 * @param properties the properties associated with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * @param properties.productsCart: Previously known ssm_products. Should contain an array of all products in the cart. Needs to be cleared on the 'Order Completed' event.
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.subcategory: This event represents a product subcategory
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be.
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page.
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.'
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * 
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/4l0ZskS226}
 */
export function pageLoaded(properties: PageLoadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = []
  eventPropertiesArray.push({
    id: 'QSRXqGwpG',
    name: 'locale_visited',
    value: properties.localeVisited,
  })
  eventPropertiesArray.push({
    id: 'NbRKFviNt',
    name: 'products_cart',
    value: properties.productsCart.map(function (value) {
      return {
        amount: value.amount,
        variation: value.variation,
        currency: value.currency,
        quantity: value.quantity,
        marketingcloudpid: value.marketingcloudpid,
        variant_id: value.variantId,
        identifier: value.identifier,
      }
    }),
  })
  eventPropertiesArray.push({
    id: 'IiKR7dr0F',
    name: 'category',
    value: properties.category,
  })
  eventPropertiesArray.push({
    id: 'BxYNUEi6TD16QuqErev17',
    name: 'subcategory',
    value: properties.subcategory,
  })
  eventPropertiesArray.push({
    id: 'jhDpoElQU',
    name: 'currency',
    value: properties.currency,
  })
  eventPropertiesArray.push({
    id: 'bCDyX8-bZ',
    name: 'country',
    value: properties.country,
  })
  eventPropertiesArray.push({
    id: '8iHihZ0rO',
    name: 'language',
    value: properties.language,
  })
  eventPropertiesArray.push({
    id: 'memdKZdQJ1',
    name: 'location_id',
    value: properties.locationId,
  })
  eventPropertiesArray.push({
    id: 'piJkZJx8sqS',
    name: 'user_id',
    value: properties.userId,
  })
  eventPropertiesArray.push({
    id: 'Kvhizl7kAi',
    name: 'logged_in',
    value: properties.loggedIn,
  })
  eventPropertiesArray.push({
    id: 'gppkY78PuY',
    name: 'page_type',
    value: properties.pageType,
  })
  properties.gaAwClid !== undefined && properties.gaAwClid !== null
    ? eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: properties.gaAwClid,
      })
    : eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: null,
      })
  properties.gaClientId !== undefined && properties.gaClientId !== null
    ? eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: properties.gaClientId,
      })
    : eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: null,
      })
  properties.gaSessionId !== undefined && properties.gaSessionId !== null
    ? eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: properties.gaSessionId,
      })
    : eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: null,
      })
  properties.gaSessionNumber !== undefined &&
  properties.gaSessionNumber !== null
    ? eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: properties.gaSessionNumber,
      })
    : eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: null,
      })
  properties.fbFbp !== undefined && properties.fbFbp !== null
    ? eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: properties.fbFbp,
      })
    : eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: null,
      })
  properties.fbFbc !== undefined && properties.fbFbc !== null
    ? eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: properties.fbFbc,
      })
    : eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: null,
      })
  eventPropertiesArray.push({
    id: 'y5SNyT2mhIug4Phnigv9w',
    name: 'application_id',
    value: sysApplicationId,
  })
  eventPropertiesArray.push({
    id: 'DMwzDVuWySom_STXGbcIW',
    name: 'version',
    value: sysVersion,
  })
  eventPropertiesArray.push({
    id: 'sp1EZQB2ui7cjP8pHZGCB',
    name: 'client_id',
    value: sysClientId,
  })
  eventPropertiesArray.push({
    id: 'tvmsJLhx1juKCS3PNg84A',
    name: 'session_id',
    value: sysSessionId,
  })
  eventPropertiesArray.push({
    id: '242drTJv3Rt-GJq3CwYuz',
    name: 'affiliateMarker',
    value: sysAffiliateMarker,
  })
  eventPropertiesArray.push({
    id: 'P-qA2e25zx5I-aiwOgIPX',
    name: 'awc',
    value: sysAwc,
  })
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = []
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = []
    messages = messages.concat(assertProductsCart(properties.productsCart))
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '4l0ZskS226',
        'ddca2632367608c9c69dd4399edffd11eb55db31de7ba5621e3a69fa6ec9a1e9',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      )
    }
    InternalAvoLogger.logEventSent(
      'Page Loaded',
      eventProperties,
      userProperties,
    )
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '4l0ZskS226',
        'Page Loaded',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      )
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Page Loaded': " + messages[0]!.message,
        )
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message)
      })
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(
        properties.customDestinationPageName_,
        (Object as any).assign({}, eventProperties),
      )
    } else {
      InternalAvoLogger.error(
        'Page method is not implemented in the destination',
        '',
      )
    }
  } else {
    // do nothing
  }
}

export interface PageLoadedCheckinProperties {
  customDestinationPageName_: string
  localeVisited: string
  productsCart: ProductsCart[]
  category: string
  subcategory: string
  currency: CurrencyValueType
  country: CountryValueType
  language: LanguageValueType
  locationId: string
  userId: string
  loggedIn: LoggedInValueType
  pageType: PageTypeValueType
  gaAwClid: string | null | undefined
  gaClientId: string | null | undefined
  gaSessionId: string | null | undefined
  gaSessionNumber: string | null | undefined
  fbFbp: string | null | undefined
  fbFbc: string | null | undefined
  eHash: string
}
/**
 * Page Loaded: When a page or a virtual page is loaded
 * for custommade: products_cart and referrer not needed, event variant
 *
 * @param properties the properties associated with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * @param properties.productsCart: Previously known ssm_products. Should contain an array of all products in the cart. Needs to be cleared on the 'Order Completed' event.
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.subcategory: This event represents a product subcategory
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be.
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page.
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.'
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.eHash: hashed email encrypted in SHA256
 *
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/4l0ZskS226.LSJGIXBzd}
 */
export function pageLoadedCheckin(properties: PageLoadedCheckinProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = []
  eventPropertiesArray.push({
    id: 'QSRXqGwpG',
    name: 'locale_visited',
    value: properties.localeVisited,
  })
  eventPropertiesArray.push({
    id: 'NbRKFviNt',
    name: 'products_cart',
    value: properties.productsCart.map(function (value) {
      return {
        amount: value.amount,
        variation: value.variation,
        currency: value.currency,
        quantity: value.quantity,
        marketingcloudpid: value.marketingcloudpid,
        variant_id: value.variantId,
        identifier: value.identifier,
      }
    }),
  })
  eventPropertiesArray.push({
    id: 'IiKR7dr0F',
    name: 'category',
    value: properties.category,
  })
  eventPropertiesArray.push({
    id: 'BxYNUEi6TD16QuqErev17',
    name: 'subcategory',
    value: properties.subcategory,
  })
  eventPropertiesArray.push({
    id: 'jhDpoElQU',
    name: 'currency',
    value: properties.currency,
  })
  eventPropertiesArray.push({
    id: 'bCDyX8-bZ',
    name: 'country',
    value: properties.country,
  })
  eventPropertiesArray.push({
    id: '8iHihZ0rO',
    name: 'language',
    value: properties.language,
  })
  eventPropertiesArray.push({
    id: 'memdKZdQJ1',
    name: 'location_id',
    value: properties.locationId,
  })
  eventPropertiesArray.push({
    id: 'piJkZJx8sqS',
    name: 'user_id',
    value: properties.userId,
  })
  eventPropertiesArray.push({
    id: 'Kvhizl7kAi',
    name: 'logged_in',
    value: properties.loggedIn,
  })
  eventPropertiesArray.push({
    id: 'gppkY78PuY',
    name: 'page_type',
    value: properties.pageType,
  })
  properties.gaAwClid !== undefined && properties.gaAwClid !== null
    ? eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: properties.gaAwClid,
      })
    : eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: null,
      })
  properties.gaClientId !== undefined && properties.gaClientId !== null
    ? eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: properties.gaClientId,
      })
    : eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: null,
      })
  properties.gaSessionId !== undefined && properties.gaSessionId !== null
    ? eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: properties.gaSessionId,
      })
    : eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: null,
      })
  properties.gaSessionNumber !== undefined &&
  properties.gaSessionNumber !== null
    ? eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: properties.gaSessionNumber,
      })
    : eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: null,
      })
  properties.fbFbp !== undefined && properties.fbFbp !== null
    ? eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: properties.fbFbp,
      })
    : eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: null,
      })
  properties.fbFbc !== undefined && properties.fbFbc !== null
    ? eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: properties.fbFbc,
      })
    : eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: null,
      })
  eventPropertiesArray.push({
    id: '2NJB6Jm5kp',
    name: 'e_hash',
    value: properties.eHash,
  })
  eventPropertiesArray.push({
    id: 'y5SNyT2mhIug4Phnigv9w',
    name: 'application_id',
    value: sysApplicationId,
  })
  eventPropertiesArray.push({
    id: 'DMwzDVuWySom_STXGbcIW',
    name: 'version',
    value: sysVersion,
  })
  eventPropertiesArray.push({
    id: 'sp1EZQB2ui7cjP8pHZGCB',
    name: 'client_id',
    value: sysClientId,
  })
  eventPropertiesArray.push({
    id: 'tvmsJLhx1juKCS3PNg84A',
    name: 'session_id',
    value: sysSessionId,
  })
  eventPropertiesArray.push({
    id: '242drTJv3Rt-GJq3CwYuz',
    name: 'affiliateMarker',
    value: sysAffiliateMarker,
  })
  eventPropertiesArray.push({
    id: 'P-qA2e25zx5I-aiwOgIPX',
    name: 'awc',
    value: sysAwc,
  })
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = []
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = []
    messages = messages.concat(assertProductsCart(properties.productsCart))
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '4l0ZskS226.LSJGIXBzd',
        '74bad90c2c86bee8fed763d78718efc75213ab8a7421748ed24ac89178aeb39d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      )
    }
    InternalAvoLogger.logEventSent(
      'Page Loaded',
      eventProperties,
      userProperties,
    )
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '4l0ZskS226.LSJGIXBzd',
        'Page Loaded',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      )
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Page Loaded': " + messages[0]!.message,
        )
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message)
      })
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(
        properties.customDestinationPageName_,
        (Object as any).assign({}, eventProperties),
      )
    } else {
      InternalAvoLogger.error(
        'Page method is not implemented in the destination',
        '',
      )
    }
  } else {
    // do nothing
  }
}

export interface PageLoadedVirtualPageViewProperties {
  customDestinationPageName_: string
  localeVisited: string
  productsCart: ProductsCart[]
  category: string
  subcategory: string
  currency: CurrencyValueType
  country: CountryValueType
  language: LanguageValueType
  locationId: string
  userId: string
  loggedIn: LoggedInValueType
  pageType: PageTypeValueType
  gaAwClid: string | null | undefined
  gaClientId: string | null | undefined
  gaSessionId: string | null | undefined
  gaSessionNumber: string | null | undefined
  fbFbp: string | null | undefined
  fbFbc: string | null | undefined
}
/**
 * Page Loaded: When a page or a virtual page is loaded
 * for custommade: products_cart and referrer not needed, event variant
 *
 * @param properties the properties associated with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * @param properties.productsCart: Previously known ssm_products. Should contain an array of all products in the cart. Needs to be cleared on the 'Order Completed' event.
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.subcategory: This event represents a product subcategory
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be.
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page.
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.'
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 *
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/4l0ZskS226.zXISHUvOO}
 */
export function pageLoadedVirtualPageView(
  properties: PageLoadedVirtualPageViewProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = []
  eventPropertiesArray.push({
    id: 'QSRXqGwpG',
    name: 'locale_visited',
    value: properties.localeVisited,
  })
  eventPropertiesArray.push({
    id: 'NbRKFviNt',
    name: 'products_cart',
    value: properties.productsCart.map(function (value) {
      return {
        amount: value.amount,
        variation: value.variation,
        currency: value.currency,
        quantity: value.quantity,
        marketingcloudpid: value.marketingcloudpid,
        variant_id: value.variantId,
        identifier: value.identifier,
      }
    }),
  })
  eventPropertiesArray.push({
    id: 'IiKR7dr0F',
    name: 'category',
    value: properties.category,
  })
  eventPropertiesArray.push({
    id: 'BxYNUEi6TD16QuqErev17',
    name: 'subcategory',
    value: properties.subcategory,
  })
  eventPropertiesArray.push({
    id: 'jhDpoElQU',
    name: 'currency',
    value: properties.currency,
  })
  eventPropertiesArray.push({
    id: 'bCDyX8-bZ',
    name: 'country',
    value: properties.country,
  })
  eventPropertiesArray.push({
    id: '8iHihZ0rO',
    name: 'language',
    value: properties.language,
  })
  eventPropertiesArray.push({
    id: 'memdKZdQJ1',
    name: 'location_id',
    value: properties.locationId,
  })
  eventPropertiesArray.push({
    id: 'piJkZJx8sqS',
    name: 'user_id',
    value: properties.userId,
  })
  eventPropertiesArray.push({
    id: 'Kvhizl7kAi',
    name: 'logged_in',
    value: properties.loggedIn,
  })
  eventPropertiesArray.push({
    id: 'gppkY78PuY',
    name: 'page_type',
    value: properties.pageType,
  })
  properties.gaAwClid !== undefined && properties.gaAwClid !== null
    ? eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: properties.gaAwClid,
      })
    : eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: null,
      })
  properties.gaClientId !== undefined && properties.gaClientId !== null
    ? eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: properties.gaClientId,
      })
    : eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: null,
      })
  properties.gaSessionId !== undefined && properties.gaSessionId !== null
    ? eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: properties.gaSessionId,
      })
    : eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: null,
      })
  properties.gaSessionNumber !== undefined &&
  properties.gaSessionNumber !== null
    ? eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: properties.gaSessionNumber,
      })
    : eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: null,
      })
  properties.fbFbp !== undefined && properties.fbFbp !== null
    ? eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: properties.fbFbp,
      })
    : eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: null,
      })
  properties.fbFbc !== undefined && properties.fbFbc !== null
    ? eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: properties.fbFbc,
      })
    : eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: null,
      })
  eventPropertiesArray.push({
    id: 'y5SNyT2mhIug4Phnigv9w',
    name: 'application_id',
    value: sysApplicationId,
  })
  eventPropertiesArray.push({
    id: 'DMwzDVuWySom_STXGbcIW',
    name: 'version',
    value: sysVersion,
  })
  eventPropertiesArray.push({
    id: 'sp1EZQB2ui7cjP8pHZGCB',
    name: 'client_id',
    value: sysClientId,
  })
  eventPropertiesArray.push({
    id: 'tvmsJLhx1juKCS3PNg84A',
    name: 'session_id',
    value: sysSessionId,
  })
  eventPropertiesArray.push({
    id: '242drTJv3Rt-GJq3CwYuz',
    name: 'affiliateMarker',
    value: sysAffiliateMarker,
  })
  eventPropertiesArray.push({
    id: 'P-qA2e25zx5I-aiwOgIPX',
    name: 'awc',
    value: sysAwc,
  })
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = []
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = []
    messages = messages.concat(assertProductsCart(properties.productsCart))
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '4l0ZskS226.zXISHUvOO',
        'e8db7890dac1d7700a0ff7b681a0e94533629311778a39b4bdf3fc9f80a62fa6',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      )
    }
    InternalAvoLogger.logEventSent(
      'Page Loaded',
      eventProperties,
      userProperties,
    )
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '4l0ZskS226.zXISHUvOO',
        'Page Loaded',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      )
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Page Loaded': " + messages[0]!.message,
        )
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message)
      })
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(
        properties.customDestinationPageName_,
        (Object as any).assign({}, eventProperties),
      )
    } else {
      InternalAvoLogger.error(
        'Page method is not implemented in the destination',
        '',
      )
    }
  } else {
    // do nothing
  }
}

export interface PageLoadedBookingtoolProperties {
  customDestinationPageName_: string
  localeVisited: string
  loggedIn: LoggedInValueType
  storeId: string
  ssSource: string | null | undefined
  ssMedium: string | null | undefined
  url: string
  country: CountryValueType
  language: LanguageValueType
  locationId: string
  userId: string
  gaAwClid: string | null | undefined
  gaClientId: string | null | undefined
  gaSessionId: string | null | undefined
  gaSessionNumber: string | null | undefined
  fbFbp: string | null | undefined
  fbFbc: string | null | undefined
}
/**
 * Page Loaded: When a page or a virtual page is loaded
 * for custommade: products_cart and referrer not needed, variant description: page loaded event in the booking tool
 *
 * @param properties the properties associated with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.ssSource: To make sure utm tags are not overwriting the utm tags from ads, we want to make sure the BT entries are tracked with the ss_medium tag. Otherwise we are not able to track the costs per lead from our facebook or other campaigns.
 * For store pages: ss_source: store_{{storename}}
 * For store experience pages: ss_source: journal_{{journal name with “-” between words}}
 * for store custommade near me: ss_source: journal_store_{{journal name with “-“ between words + store parameter in new landing pages}}
 * @param properties.ssMedium: To make sure utm tags are not overwriting the utm tags from ads, we want to make sure the BT entries are tracked with the ss_medium tag. Otherwise we are not able to track the costs per lead from our facebook or other campaigns., should match regex: ^$|bt_panel|cs_panel
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be.
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page.
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 *
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/4l0ZskS226.wZGKatH9x}
 */
export function pageLoadedBookingtool(
  properties: PageLoadedBookingtoolProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = []
  eventPropertiesArray.push({
    id: 'QSRXqGwpG',
    name: 'locale_visited',
    value: properties.localeVisited,
  })
  eventPropertiesArray.push({
    id: 'Kvhizl7kAi',
    name: 'logged_in',
    value: properties.loggedIn,
  })
  eventPropertiesArray.push({
    id: 'EnoheN1kA',
    name: 'store_id',
    value: properties.storeId,
  })
  properties.ssSource !== undefined && properties.ssSource !== null
    ? eventPropertiesArray.push({
        id: 'PBq0iEV4f',
        name: 'ss_source',
        value: properties.ssSource,
      })
    : eventPropertiesArray.push({
        id: 'PBq0iEV4f',
        name: 'ss_source',
        value: null,
      })
  properties.ssMedium !== undefined && properties.ssMedium !== null
    ? eventPropertiesArray.push({
        id: 'dCzQ_0RdM',
        name: 'ss_medium',
        value: properties.ssMedium,
      })
    : eventPropertiesArray.push({
        id: 'dCzQ_0RdM',
        name: 'ss_medium',
        value: null,
      })
  eventPropertiesArray.push({
    id: 'olJP9CQ0tb',
    name: 'url',
    value: properties.url,
  })
  eventPropertiesArray.push({
    id: 'bCDyX8-bZ',
    name: 'country',
    value: properties.country,
  })
  eventPropertiesArray.push({
    id: '8iHihZ0rO',
    name: 'language',
    value: properties.language,
  })
  eventPropertiesArray.push({
    id: 'memdKZdQJ1',
    name: 'location_id',
    value: properties.locationId,
  })
  eventPropertiesArray.push({
    id: 'piJkZJx8sqS',
    name: 'user_id',
    value: properties.userId,
  })
  properties.gaAwClid !== undefined && properties.gaAwClid !== null
    ? eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: properties.gaAwClid,
      })
    : eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: null,
      })
  properties.gaClientId !== undefined && properties.gaClientId !== null
    ? eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: properties.gaClientId,
      })
    : eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: null,
      })
  properties.gaSessionId !== undefined && properties.gaSessionId !== null
    ? eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: properties.gaSessionId,
      })
    : eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: null,
      })
  properties.gaSessionNumber !== undefined &&
  properties.gaSessionNumber !== null
    ? eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: properties.gaSessionNumber,
      })
    : eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: null,
      })
  properties.fbFbp !== undefined && properties.fbFbp !== null
    ? eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: properties.fbFbp,
      })
    : eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: null,
      })
  properties.fbFbc !== undefined && properties.fbFbc !== null
    ? eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: properties.fbFbc,
      })
    : eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: null,
      })
  eventPropertiesArray.push({
    id: 'gppkY78PuY',
    name: 'page_type',
    value: 'booking_tool',
  })
  eventPropertiesArray.push({
    id: 'y5SNyT2mhIug4Phnigv9w',
    name: 'application_id',
    value: sysApplicationId,
  })
  eventPropertiesArray.push({
    id: 'DMwzDVuWySom_STXGbcIW',
    name: 'version',
    value: sysVersion,
  })
  eventPropertiesArray.push({
    id: 'sp1EZQB2ui7cjP8pHZGCB',
    name: 'client_id',
    value: sysClientId,
  })
  eventPropertiesArray.push({
    id: 'tvmsJLhx1juKCS3PNg84A',
    name: 'session_id',
    value: sysSessionId,
  })
  eventPropertiesArray.push({
    id: '242drTJv3Rt-GJq3CwYuz',
    name: 'affiliateMarker',
    value: sysAffiliateMarker,
  })
  eventPropertiesArray.push({
    id: 'P-qA2e25zx5I-aiwOgIPX',
    name: 'awc',
    value: sysAwc,
  })
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = []
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = []
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '4l0ZskS226.wZGKatH9x',
        '082621e6234930865d387773b0061bde132a9de40ff37e0b652679bb50492260',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      )
    }
    InternalAvoLogger.logEventSent(
      'Page Loaded',
      eventProperties,
      userProperties,
    )
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '4l0ZskS226.wZGKatH9x',
        'Page Loaded',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      )
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(
        properties.customDestinationPageName_,
        (Object as any).assign({}, eventProperties),
      )
    } else {
      InternalAvoLogger.error(
        'Page method is not implemented in the destination',
        '',
      )
    }
  } else {
    // do nothing
  }
}

export interface PageLoadedCmProperties {
  customDestinationPageName_: string
  localeVisited: string
  productsCart: ProductsCart[]
  category: string
  subcategory: string
  currency: CurrencyValueType
  country: CountryValueType
  language: LanguageValueType
  locationId: string
  userId: string
  loggedIn: LoggedInValueType
  pageType: PageTypeValueType
  gaAwClid: string | null | undefined
  gaClientId: string | null | undefined
  gaSessionId: string | null | undefined
  gaSessionNumber: string | null | undefined
  fbFbp: string | null | undefined
  fbFbc: string | null | undefined
}
/**
 * Page Loaded: When a page or a virtual page is loaded
 * for custommade: products_cart and referrer not needed, event variant
 *
 * @param properties the properties associated with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.localeVisited: Locale visited, for example en-us or es-us
 * @param properties.productsCart: Previously known ssm_products. Should contain an array of all products in the cart. Needs to be cleared on the 'Order Completed' event.
 * @param properties.category: This event represents a product category, should match regex: ^(|belts|coats|cufflinks|gift card|gift-wrapping|gloves|handkerchiefs|hats|jackets|knitwear|scarves|shirts|shoecare|shoes|shorts|socks|suits|suspenders|ties|tiessub|trousers|waistcoats)$
 * @param properties.subcategory: This event represents a product subcategory
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be.
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page.
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.'
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 *
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/4l0ZskS226.L14A1aHRF}
 */
export function pageLoadedCm(properties: PageLoadedCmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = []
  eventPropertiesArray.push({
    id: 'QSRXqGwpG',
    name: 'locale_visited',
    value: properties.localeVisited,
  })
  eventPropertiesArray.push({
    id: 'NbRKFviNt',
    name: 'products_cart',
    value: properties.productsCart.map(function (value) {
      return {
        amount: value.amount,
        variation: value.variation,
        currency: value.currency,
        quantity: value.quantity,
        marketingcloudpid: value.marketingcloudpid,
        variant_id: value.variantId,
        identifier: value.identifier,
      }
    }),
  })
  eventPropertiesArray.push({
    id: 'IiKR7dr0F',
    name: 'category',
    value: properties.category,
  })
  eventPropertiesArray.push({
    id: 'BxYNUEi6TD16QuqErev17',
    name: 'subcategory',
    value: properties.subcategory,
  })
  eventPropertiesArray.push({
    id: 'jhDpoElQU',
    name: 'currency',
    value: properties.currency,
  })
  eventPropertiesArray.push({
    id: 'bCDyX8-bZ',
    name: 'country',
    value: properties.country,
  })
  eventPropertiesArray.push({
    id: '8iHihZ0rO',
    name: 'language',
    value: properties.language,
  })
  eventPropertiesArray.push({
    id: 'memdKZdQJ1',
    name: 'location_id',
    value: properties.locationId,
  })
  eventPropertiesArray.push({
    id: 'piJkZJx8sqS',
    name: 'user_id',
    value: properties.userId,
  })
  eventPropertiesArray.push({
    id: 'Kvhizl7kAi',
    name: 'logged_in',
    value: properties.loggedIn,
  })
  eventPropertiesArray.push({
    id: 'gppkY78PuY',
    name: 'page_type',
    value: properties.pageType,
  })
  properties.gaAwClid !== undefined && properties.gaAwClid !== null
    ? eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: properties.gaAwClid,
      })
    : eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: null,
      })
  properties.gaClientId !== undefined && properties.gaClientId !== null
    ? eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: properties.gaClientId,
      })
    : eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: null,
      })
  properties.gaSessionId !== undefined && properties.gaSessionId !== null
    ? eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: properties.gaSessionId,
      })
    : eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: null,
      })
  properties.gaSessionNumber !== undefined &&
  properties.gaSessionNumber !== null
    ? eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: properties.gaSessionNumber,
      })
    : eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: null,
      })
  properties.fbFbp !== undefined && properties.fbFbp !== null
    ? eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: properties.fbFbp,
      })
    : eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: null,
      })
  properties.fbFbc !== undefined && properties.fbFbc !== null
    ? eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: properties.fbFbc,
      })
    : eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: null,
      })
  eventPropertiesArray.push({
    id: 'y5SNyT2mhIug4Phnigv9w',
    name: 'application_id',
    value: sysApplicationId,
  })
  eventPropertiesArray.push({
    id: 'DMwzDVuWySom_STXGbcIW',
    name: 'version',
    value: sysVersion,
  })
  eventPropertiesArray.push({
    id: 'sp1EZQB2ui7cjP8pHZGCB',
    name: 'client_id',
    value: sysClientId,
  })
  eventPropertiesArray.push({
    id: 'tvmsJLhx1juKCS3PNg84A',
    name: 'session_id',
    value: sysSessionId,
  })
  eventPropertiesArray.push({
    id: '242drTJv3Rt-GJq3CwYuz',
    name: 'affiliateMarker',
    value: sysAffiliateMarker,
  })
  eventPropertiesArray.push({
    id: 'P-qA2e25zx5I-aiwOgIPX',
    name: 'awc',
    value: sysAwc,
  })
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = []
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = []
    messages = messages.concat(assertProductsCart(properties.productsCart))
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '4l0ZskS226.L14A1aHRF',
        '1bcb98d453dbaba03133b188f5ac80f1805f9bfa11eacba9e0bc3073387f4c4f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      )
    }
    InternalAvoLogger.logEventSent(
      'Page Loaded',
      eventProperties,
      userProperties,
    )
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '4l0ZskS226.L14A1aHRF',
        'Page Loaded',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      )
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'Page Loaded': " + messages[0]!.message,
        )
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message)
      })
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(
        properties.customDestinationPageName_,
        (Object as any).assign({}, eventProperties),
      )
    } else {
      InternalAvoLogger.error(
        'Page method is not implemented in the destination',
        '',
      )
    }
  } else {
    // do nothing
  }
}

export interface PageLoadedPredictSpringProperties {
  customDestinationPageName_: string
  userId: string
  pageType: PageTypeValueType
  storeId: string
  country: CountryValueType
}
/**
 * Page Loaded: When a page or a virtual page is loaded
 * for custommade: products_cart and referrer not needed, variant description: This event represents the Page loaded for the Predict Spring App. It is triggered when a page is loaded on the application.
 * The page_type is yet to defined
 *
 * @param properties the properties associated with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.'
 * @param properties.storeId: Predict spring store id, for example:
 * - For Amsterdam: 7
 * - For Antwerp: 66
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be.
 *
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/4l0ZskS226.GGPbZLNhh1MeQvaOX1shQ}
 */
export function pageLoadedPredictSpring(
  properties: PageLoadedPredictSpringProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = []
  eventPropertiesArray.push({
    id: 'piJkZJx8sqS',
    name: 'user_id',
    value: properties.userId,
  })
  eventPropertiesArray.push({
    id: 'gppkY78PuY',
    name: 'page_type',
    value: properties.pageType,
  })
  eventPropertiesArray.push({
    id: 'EnoheN1kA',
    name: 'store_id',
    value: properties.storeId,
  })
  eventPropertiesArray.push({
    id: 'bCDyX8-bZ',
    name: 'country',
    value: properties.country,
  })
  eventPropertiesArray.push({
    id: 'y5SNyT2mhIug4Phnigv9w',
    name: 'application_id',
    value: sysApplicationId,
  })
  eventPropertiesArray.push({
    id: 'DMwzDVuWySom_STXGbcIW',
    name: 'version',
    value: sysVersion,
  })
  eventPropertiesArray.push({
    id: 'sp1EZQB2ui7cjP8pHZGCB',
    name: 'client_id',
    value: sysClientId,
  })
  eventPropertiesArray.push({
    id: 'tvmsJLhx1juKCS3PNg84A',
    name: 'session_id',
    value: sysSessionId,
  })
  eventPropertiesArray.push({
    id: '242drTJv3Rt-GJq3CwYuz',
    name: 'affiliateMarker',
    value: sysAffiliateMarker,
  })
  eventPropertiesArray.push({
    id: 'P-qA2e25zx5I-aiwOgIPX',
    name: 'awc',
    value: sysAwc,
  })
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = []
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = []
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '4l0ZskS226.GGPbZLNhh1MeQvaOX1shQ',
        'a5f3e0630a8e46dbac8b82eed182ecff1010a01c720bcd67b9b48301c5be50e3',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      )
    }
    InternalAvoLogger.logEventSent(
      'Page Loaded',
      eventProperties,
      userProperties,
    )
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '4l0ZskS226.GGPbZLNhh1MeQvaOX1shQ',
        'Page Loaded',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      )
    }
  }
  if (!__AVO_NOOP__) {
    // destination Segment
    if (Segment.logPage) {
      Segment.logPage(
        properties.customDestinationPageName_,
        (Object as any).assign({}, eventProperties),
      )
    } else {
      InternalAvoLogger.error(
        'Page method is not implemented in the destination',
        '',
      )
    }
  } else {
    // do nothing
  }
}

export interface PreferencesSavedProperties {
  currency: CurrencyValueType
  country: CountryValueType
  language: LanguageValueType
  url: string
  locationId: string
  userId: string
  loggedIn: LoggedInValueType
  pageType: PageTypeValueType
  gaClientId: string | null | undefined
  gaSessionId: string | null | undefined
  gaSessionNumber: string | null | undefined
  fbFbp: string | null | undefined
  fbFbc: string | null | undefined
  gaAwClid: string | null | undefined
  eventLabel: string | null | undefined
  eventCategory: EventCategoryValueType | null | undefined
  eventLocation: string
  communicationPreferences: CommunicationPreferences
}
/**
 * preferences_saved: This event described when the customer has saved communication preferences
 *
 * When to trigger this event:
 * 1. when the user clicks "save preferences"
 * View in Avo: https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/N6CHO6B8mWvD4lvsmcmRb/trigger/jiArMR2idnn0in04cFW1C
 *
 * @param properties the properties associated with this event
 * @param properties.currency: This property denotes the currency used on the website, represented by a three-letter code in accordance with the ISO 4217 standard. The code should be presented in lowercase letters. Eg: aed, aud, bgn, cad.
 * @param properties.country: This property represents the local country associated with the website, formatted as a two-letter code in accordance with the ISO 3166-1 alpha-2 standard. The code should be in lowercase letters. Eg: ae, at, au, be.
 * @param properties.language: This property indicates the language utilized on the page, represented in accordance with the ISO 639-1 standard. The language code should be formatted in lowercase letters.
 * @param properties.url: This property contains the URL of the page without any locale information included. This version of the URL provides a standardized reference to the page, allowing for easier tracking and analysis of user interactions without the influence of language or regional variations.
 * @param properties.locationId: This property refers to the URL that includes the locale, indicating the specific language or region associated with the page.
 * @param properties.userId: This property represents a unique identifier for the customer, typically corresponding to their account number. This identifier is essential for distinguishing individual customers within the system, facilitating personalized interactions and enabling accurate tracking of customer-related data and activities.
 * @param properties.loggedIn: This property represents a boolean value that indicates whether the user is logged in to the system. A value of true signifies that the user is currently logged in, while false indicates that the user is not logged in.
 * @param properties.pageType: This property provides a description of the type of page currently being viewed, such as 'homepage,' 'product page,' or 'category page.'
 * @param properties.gaClientId: This property contains the client ID retrieved from localstorage.client_id, which is used to uniquely identify users in Google Analytics. The client ID plays a crucial role in tracking user interactions across sessions and devices, enabling a comprehensive understanding of user behavior and engagement on the website.
 * @param properties.gaSessionId: This property contains the Google Analytics session ID retrieved from localstorage.session_id, which is utilized to track user sessions on the website. The session ID is essential for distinguishing individual user interactions within a specific session, allowing for detailed analysis of user behavior and engagement patterns.
 * @param properties.gaSessionNumber: This property represents the session number retrieved from localstorage.session_number, indicating the total number of sessions a user has engaged in on the website. The session number is useful for understanding user behavior over time and assessing user retention and engagement trends.
 * @param properties.fbFbp: This property represents the value of the Facebook Browser ID (_fbp) cookie, which is employed for tracking user sessions on the website. The fbp cookie enables the identification of unique users and helps in analyzing user behavior across sessions, thereby facilitating effective ad targeting and performance measurement.
 * @param properties.fbFbc: This property captures the value of the Facebook Click ID cookie (_fbc), which is utilized for tracking user interactions on the website. The fbc cookie helps in attributing conversions and understanding user behavior by linking actions taken on the site back to specific Facebook ad clicks.
 * @param properties.gaAwClid: This property captures the Google AdWords Click ID (_gcl_aw), which is utilized to track clicks originating from Google Ads. The Click ID facilitates the attribution of conversions to specific ad interactions, allowing for comprehensive analysis of ad performance and user engagement.
 * @param properties.eventLabel: Description of event, not always required
 * @param properties.eventCategory: This property represents which category the event should be listed in. With this, the data can be separated into different domains so we can analyze the data accordingly. For example, in custom made, we have multiple size passport events when the user is
 * @param properties.eventLocation: This property describers the location of the element that triggered the event. It can be a panel, a slider, a promotion block and etc. Some value can be found below
 * - For wishlist panel: wishlist_panel
 * - For add to bag panel: minicart_panel
 * - For OOS panel: oos
 * - For out-of-stock panel: out_of_stock_panel
 * - For shop the look panel: 'products_mwtw_{{number}}'
 * - For mix and match panel: mixandmatch
 * - for Perfect White shirt finder: pwsf_panel
 * - For Size Passport: size-passport_panel
 * - For PDP size guide button: pdp
 * - For LB: lookbuilder_summary
 * - For Similar Products: similar_products_panel
 * For order list page: order_list
 * for order details page: order_details
 * @param properties.communicationPreferences: The customer's communication preferences
 *
 * @see {@link https://www.avo.app/schemas/JmwsgKTQe50MTmUE9FVs/branches/PsRDMgOzKdvBCPbWYW9XO/events/N6CHO6B8mWvD4lvsmcmRb}
 */
export function preferencesSaved(properties: PreferencesSavedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = []
  eventPropertiesArray.push({
    id: 'jhDpoElQU',
    name: 'currency',
    value: properties.currency,
  })
  eventPropertiesArray.push({
    id: 'bCDyX8-bZ',
    name: 'country',
    value: properties.country,
  })
  eventPropertiesArray.push({
    id: '8iHihZ0rO',
    name: 'language',
    value: properties.language,
  })
  eventPropertiesArray.push({
    id: 'olJP9CQ0tb',
    name: 'url',
    value: properties.url,
  })
  eventPropertiesArray.push({
    id: 'memdKZdQJ1',
    name: 'location_id',
    value: properties.locationId,
  })
  eventPropertiesArray.push({
    id: 'piJkZJx8sqS',
    name: 'user_id',
    value: properties.userId,
  })
  eventPropertiesArray.push({
    id: 'Kvhizl7kAi',
    name: 'logged_in',
    value: properties.loggedIn,
  })
  eventPropertiesArray.push({
    id: 'gppkY78PuY',
    name: 'page_type',
    value: properties.pageType,
  })
  properties.gaClientId !== undefined && properties.gaClientId !== null
    ? eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: properties.gaClientId,
      })
    : eventPropertiesArray.push({
        id: 'ba9__C5yS',
        name: 'ga_client_id',
        value: null,
      })
  properties.gaSessionId !== undefined && properties.gaSessionId !== null
    ? eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: properties.gaSessionId,
      })
    : eventPropertiesArray.push({
        id: 'sFU-LulvR',
        name: 'ga_session_id',
        value: null,
      })
  properties.gaSessionNumber !== undefined &&
  properties.gaSessionNumber !== null
    ? eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: properties.gaSessionNumber,
      })
    : eventPropertiesArray.push({
        id: 'QQnci_8-j',
        name: 'ga_session_number',
        value: null,
      })
  properties.fbFbp !== undefined && properties.fbFbp !== null
    ? eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: properties.fbFbp,
      })
    : eventPropertiesArray.push({
        id: 'MlkVULjI2U',
        name: 'fb_fbp',
        value: null,
      })
  properties.fbFbc !== undefined && properties.fbFbc !== null
    ? eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: properties.fbFbc,
      })
    : eventPropertiesArray.push({
        id: 'ftuMAZCD8',
        name: 'fb_fbc',
        value: null,
      })
  properties.gaAwClid !== undefined && properties.gaAwClid !== null
    ? eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: properties.gaAwClid,
      })
    : eventPropertiesArray.push({
        id: 'tUxjzh1QQ',
        name: 'ga_aw_clid',
        value: null,
      })
  properties.eventLabel !== undefined && properties.eventLabel !== null
    ? eventPropertiesArray.push({
        id: '5mI3k6x6_',
        name: 'event_label',
        value: properties.eventLabel,
      })
    : eventPropertiesArray.push({
        id: '5mI3k6x6_',
        name: 'event_label',
        value: null,
      })
  properties.eventCategory !== undefined && properties.eventCategory !== null
    ? eventPropertiesArray.push({
        id: 'VdCb01TKRz',
        name: 'event_category',
        value: properties.eventCategory,
      })
    : eventPropertiesArray.push({
        id: 'VdCb01TKRz',
        name: 'event_category',
        value: null,
      })
  eventPropertiesArray.push({
    id: 'te07FO5wjg',
    name: 'event_location',
    value: properties.eventLocation,
  })
  eventPropertiesArray.push({
    id: 'sDlh7c0yvS7a0T6AcoGcQ',
    name: 'communication_preferences',
    value: {
      communication_language:
        properties.communicationPreferences.communicationLanguage,
      newsletter_status: properties.communicationPreferences.newsletterStatus,
      curated_for_you_status:
        properties.communicationPreferences.curatedForYouStatus,
    },
  })
  eventPropertiesArray.push({
    id: 'y5SNyT2mhIug4Phnigv9w',
    name: 'application_id',
    value: sysApplicationId,
  })
  eventPropertiesArray.push({
    id: 'DMwzDVuWySom_STXGbcIW',
    name: 'version',
    value: sysVersion,
  })
  eventPropertiesArray.push({
    id: 'sp1EZQB2ui7cjP8pHZGCB',
    name: 'client_id',
    value: sysClientId,
  })
  eventPropertiesArray.push({
    id: 'tvmsJLhx1juKCS3PNg84A',
    name: 'session_id',
    value: sysSessionId,
  })
  eventPropertiesArray.push({
    id: '242drTJv3Rt-GJq3CwYuz',
    name: 'affiliateMarker',
    value: sysAffiliateMarker,
  })
  eventPropertiesArray.push({
    id: 'P-qA2e25zx5I-aiwOgIPX',
    name: 'awc',
    value: sysAwc,
  })
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = []
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = []
    messages = messages.concat(
      assertCommunicationPreferences(properties.communicationPreferences),
    )
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'N6CHO6B8mWvD4lvsmcmRb',
        '5bd67bfd27eaba046faf2ddda97410cf4297a9418957400e704de5d44f85d770',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      )
    }
    InternalAvoLogger.logEventSent(
      'preferences_saved',
      eventProperties,
      userProperties,
    )
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'N6CHO6B8mWvD4lvsmcmRb',
        'preferences_saved',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      )
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error(
          "Error sending event 'preferences_saved': " + messages[0]!.message,
        )
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message)
      })
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'preferences_saved',
        eventProperties,
        'N6CHO6B8mWvD4lvsmcmRb',
        '5bd67bfd27eaba046faf2ddda97410cf4297a9418957400e704de5d44f85d770',
      )
    }
    // destination Segment
    Segment.logEvent(
      'preferences_saved',
      (Object as any).assign({}, eventProperties),
    )
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  Language,
  LoggedIn,
  EventCategory,
  Country,
  PageType,
  Currency,
  ApplicationId,
  pageLoaded,
  pageLoadedCheckin,
  pageLoadedVirtualPageView,
  pageLoadedBookingtool,
  pageLoadedCm,
  pageLoadedPredictSpring,
  preferencesSaved,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["pageLoaded","pageLoadedCheckin","pageLoadedVirtualPageView","pageLoadedBookingtool","pageLoadedCm","pageLoadedPredictSpring","preferencesSaved"]
